import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import _ from 'lodash';
import * as Actions from '../actions/OrganizerList';

const GetProductsSmallBoothReducer = handleActions({
    [Actions.getEventProductsSmallZoneRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getEventProductsSmallZoneReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getEventProductsSmallZoneReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getEventProductsSmallZoneClear]: () => ({
        isFetching: false,
        data: { results: [] },
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: { results: [] },
    errors: {},
    success: undefined,
});

const GetProductsStandardBoothReducer = handleActions({
    [Actions.getEventProductsStandardZoneRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getEventProductsStandardZoneReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getEventProductsStandardZoneReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getEventProductsStandardZoneClear]: () => ({
        isFetching: false,
        data: { results: [] },
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: { results: [] },
    errors: {},
    success: undefined,
});

const GetProductsBigBoothReducer = handleActions({
    [Actions.getEventProductsBigZoneRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getEventProductsBigZoneReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getEventProductsBigZoneReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getEventProductsBigZoneClear]: () => ({
        isFetching: false,
        data: { results: [] },
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: { results: [] },
    errors: {},
    success: undefined,
});

const GetProductsGrandBoothReducer = handleActions({
    [Actions.getEventProductsGrandZoneRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getEventProductsGrandZoneReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getEventProductsGrandZoneReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getEventProductsGrandZoneClear]: () => ({
        isFetching: false,
        data: { results: [] },
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: { results: [] },
    errors: {},
    success: undefined,
});

const GetProductsReducer = handleActions({
    [Actions.getEventProductsRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getEventProductsReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        listProduct: { results: !_.isEmpty(action.payload.results) ? state.data.results.concat(action.payload.results) : action.payload.results },
        success: true,
    }),
    [Actions.getEventProductsReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        listProduct: { results: [] },
        success: false,
    }),
    [Actions.getEventProductsClear]: () => ({
        isFetching: false,
        data: { results: [] },
        errors: {},
        success: undefined,
        listProduct: { results: [] },
    }),
}, {
    isFetching: false,
    data: { results: [] },
    errors: {},
    listProduct: { results: [] },
    success: undefined,
});

const setSelectedOrganizerReducer = handleActions({
    [Actions.setSelectedOrganizers]: (state, action) => ({
        ...state,
        organizers: action.payload,
    }),
    [Actions.clearSelectedOrganizers]: (state) => ({
        ...state,
        organizers: {},
    }),
}, {
    organizers: {},
});

const setSearchConditionReducer = handleActions({
    [Actions.setSearchCondition]: (state, action) => ({
        ...state,
        data: action.payload,
    }),
    [Actions.clearSearchCondition]: (state) => ({
        ...state,
        data: {},
    }),
}, {
    data: {},
});

const viewModeReducer = handleActions({
    [Actions.setViewMode]: (state, action) => ({
        ...state,
        viewMode: action.payload,
    }),
}, {
    viewMode: false,
});

export default combineReducers({
    getSmallBooth: GetProductsSmallBoothReducer,
    getStandardBooth: GetProductsStandardBoothReducer,
    getBigBooth: GetProductsBigBoothReducer,
    getGrandBooth: GetProductsGrandBoothReducer,
    getProducts: GetProductsReducer,
    selectedOrganizer: setSelectedOrganizerReducer,
    searchData: setSearchConditionReducer,
    viewMode: viewModeReducer,
});
